var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "flex flex_gap_5 flex-wrap store_blocks mb-1" },
      [
        _c("div", {
          domProps: { innerHTML: _vm._s(_vm.getStoreInfoByStore(_vm.storeId)) },
        }),
        _vm._v(" "),
        _vm._l(_vm.stores, function (s) {
          return [
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.getStoreInfoByStore(s)) },
            }),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }